import { render } from "./PreviewFacebook.vue?vue&type=template&id=5a96788b&scoped=true"
import script from "./PreviewFacebook.vue?vue&type=script&lang=js"
export * from "./PreviewFacebook.vue?vue&type=script&lang=js"

import "./PreviewFacebook.vue?vue&type=style&index=0&id=5a96788b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a96788b"]])

export default __exports__